import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Typography, Paper } from '@mui/material';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import logo from '../assets/images/logo.jpg';
import { useLanguage } from '../translations/LanguageContext';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { translations } = useLanguage();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          mt: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 4,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 4,
            background: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(10px)',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
          }}
        >
          <img 
            src={logo} 
            alt="EcoQuiz Logo" 
            style={{ 
              width: '120px', 
              height: 'auto',
              marginBottom: '16px'
            }} 
          />
          <Typography 
            variant="h2" 
            component="h1" 
            gutterBottom
            sx={{
              fontWeight: 500,
              color: 'primary.main',
              textAlign: 'center',
            }}
          >
            {translations.home.welcome}
          </Typography>
          <Typography 
            variant="h6" 
            align="center" 
            color="text.secondary" 
            sx={{ mb: 3 }}
          >
            {translations.home.description}
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, width: '100%' }}>
            <Button
              variant="contained"
              size="large"
              fullWidth
              onClick={() => navigate('/game')}
            >
              {translations.home.startGame}
            </Button>
            <Button
              variant="outlined"
              size="large"
              fullWidth
              onClick={() => navigate('/leaderboard')}
              startIcon={<LeaderboardIcon />}
            >
              {translations.common.leaderboard}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default HomePage; 